export default {
    init($) {
      
        var emailSection = $(".checkout-email-section")
        var checkoutBillingSection = $(".checkout-billing-section")

        //move #billing_email_field to #billing_email_wrapper
        $('#billing_email_field').appendTo('#billing_email_wrapper')

        $('#autofill_address_field').append('<div class="billing-manually-button">Enter address manually</div>');
        $('#autofill_address_shipping_field').append('<div class="shipping-manually-button">Enter address manually</div>');

        // If user is logged in, show the billing fields
        if ($('.checkout-billing-section').hasClass('is-logged-in')) {
            $('.woocommerce-billing-fields').find('.billing-hidden').removeClass('billing-hidden')
            $('#autofill_address_field').hide()

            // if checkbox differentShipping is checked, show the shipping fields 
            if ($('#ship-to-different-address-checkbox').is(':checked')) {
                $('.woocommerce-shipping-fields').find('.shipping-hidden').removeClass('shipping-hidden')
                $('#autofill_address_shipping_field').hide()
            }
        }

        if ($('.checkout-billing-section').hasClass('is-logged-in validated')) {
            $('#payment-wrap').show()
            $('.checkout-icons').removeClass('mobile-hidden')
            $('.checkout-reviews').removeClass('mobile-hidden')
        }

        // If user email exists, show the email section
        $(document).on('checkout_error', function () {
            let errorType = $('.woocommerce-error li').text()

            if (errorType.includes('account is already registered')) {
                $('.checkout-email-section').removeClass('validated')
            }
        })


        $(document).on('click', '.billing-manually-button', function () {
            $('.woocommerce-billing-fields').find('.billing-hidden').removeClass('billing-hidden')
            $('#autofill_address_field').hide()

            $('form.checkout #billing-section select').select2({
                'width': '100%'
            })
        })

        $(document).on('click', '.shipping-manually-button', function () {
            $('.woocommerce-shipping-fields').find('.shipping-hidden').removeClass('shipping-hidden')
            $('#autofill_address_shipping_field').hide()

            $('form.checkout #billing-section select').select2({
                'width': '100%'
            })
        })

        $("#checkout-email-continue").on("click", function (e) {
            e.preventDefault()

            const requiredFieldsEmail = $("form.checkout .checkout-email-section.row-wrap .validate-required")

            let isValid = true

            //check if email is valid - that means also in right email format with @ and domain
            if (!isValidEmail($('#billing_email').val())) {
                $('#billing_email_field').addClass("woocommerce-invalid")
                $('#billing_email_field').addClass("woocommerce-invalid-required-field")
                isValid = false
                return
            } else {
                $('#billing_email_field').removeClass("woocommerce-invalid")
                $('#billing_email_field').removeClass("woocommerce-invalid-required-field")
            }



            // Loop through the required fields and check if they have a value
            requiredFieldsEmail.each(function () {
                // Check if the field is visible
                if ($(this).is(":visible")) {
                    const input = $(this).find("input, select, textarea");
                    if (!input.val().trim()) {
                        $(this).addClass("woocommerce-invalid"); // Add a class to style invalid fields
                        $(this).addClass("woocommerce-invalid-required-field"); // Add a class to style invalid fields
                        isValid = false
                    } else {
                        $(this).removeClass("woocommerce-invalid")
                        $(this).removeClass("woocommerce-invalid-required-field")
                    }
                }
            })

            if (isValid) {
                emailSection.addClass("validated")

                let billing_email_value = $('#billing_email').val()

                $('.checkout-email-section__view-email span').text(billing_email_value)

                $('#autofill_address').val($('#billing_address_1').val()) // Fill out the autofill address field

                // If all required fields have a value, submit the form
                $(".checkout-billing-section").slideDown();
                $("#billing-section").addClass("open");

                $('.checkout-icons').removeClass('mobile-hidden')

                $("html, body").animate({
                    scrollTop: $("#billing-section").offset().top - 50,
                }, "slow")
                

                // send email to Klaviyo
                // if (typeof klaviyo !== 'undefined') {
                //     klaviyo.identify({
                //         'email' : billing_email_value,
                //     });
                // }

                $('form.checkout #billing-section select').select2({
                    'width': '100%'
                })


                // Save email address to BRAZE list
                $.ajax({
                    url: my_ajax_object.ajax_url,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'braze_started_checkout_event',
                        nonce: my_ajax_object.nonce,
                        email_address: billing_email_value,
                    },
                    error: function(xhr, status, error) {
                        console.error('Failed to save data ' + error);
                    }
                })


                // Save email address to Klaviyo list
                // $.ajax({
                //     url: my_ajax_object.ajax_url,
                //     type: 'POST',
                //     dataType: 'json',
                //     data: {
                //         action: 'save_checkout_email_to_klaviyo_list',
                //         email_address: billing_email_value,
                //     },
                //     error: function(xhr, status, error) {
                //         console.error('Failed to save data ' + error);
                //     }
                // })

            }
        })



        // Validate the billing fields on load, and show/hide the fields
        const requiredBillingFields = $("form.checkout .checkout-billing-section .woocommerce-billing-fields__field-wrapper .validate-required")
        let isBillingValid = true
        requiredBillingFields.each(function () {
            const input = $(this).find("input, select, textarea");
            if (!input.val().trim()) {
                isBillingValid = false
            }
        })
        if (isBillingValid) {
            $('.woocommerce-billing-fields').find('.billing-hidden').removeClass('billing-hidden')
            $('#autofill_address_field').hide()

            checkoutBillingSection.addClass("validated")

            $('.checkout-icons').removeClass('mobile-hidden')
        }
   


        // Validate the shipping fields on load, and show/hide the fields
        const requiredShippingFields = $("form.checkout .checkout-billing-section .woocommerce-shipping-fields__field-wrapper .validate-required")
        let isShippingValid = true
        requiredShippingFields.each(function () {
            const input = $(this).find("input, select, textarea");
            if (!input.val().trim()) {
                isShippingValid = false
            }
        })
        if (isShippingValid) {
            $('.woocommerce-shipping-fields').find('.shipping-hidden').removeClass('shipping-hidden')
            $('#autofill_address_shipping_field').hide()
        } else if ($('#ship-to-different-address-checkbox').is(':checked')) {
            checkoutBillingSection.removeClass("validated")
        }
   

        $(document).on('change', '#ship-to-different-address-checkbox', function () {
            if ($(this).is(':checked')) {
                $('.address_subtitle_toggle').show()
            } else {
                $('.address_subtitle_toggle').hide()
            }
        })


        // Edit email address
        let editEmailSection = emailSection.find(".edit-link")

        editEmailSection.on("click", function (e) {
            e.preventDefault()
            emailSection.removeClass("validated")
            checkoutBillingSection.hide()
            $('.payment-wrap').hide()
            $('.checkout-icons').addClass('mobile-hidden')
            $('.checkout-reviews').addClass('mobile-hidden')

            $("html, body").animate({
                scrollTop: $(emailSection).offset().top - 50,
            }, "slow")
            
            $("#checkout-continue").show()
        })
  


        // Edit Billing address
        checkoutBillingSection.on('click', '.edit-link', function (e) {
            e.preventDefault()
            checkoutBillingSection.removeClass("validated")
            $('.payment-wrap').hide()
            $('.checkout-icons').addClass('mobile-hidden')
            $('.checkout-reviews').addClass('mobile-hidden')

            $("html, body").animate({
                scrollTop: checkoutBillingSection.offset().top - 50,
            }, "slow")

            $('form.checkout #billing-section select').select2({
                'width': '100%'
            }) 

            $("#checkout-continue").show()
        })


        function isValidEmail(email) {
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
        }


        // Additional "Express checkout" text on checkout Stripe express
        $('.wc-stripe-banner-checkout').prepend('<div class="stripe-express-checkout-title">Express checkout</div>')

    },


    mobileCheckoutView($) {
        
        // Copy content to mobile checkout expander
        $(document).on('updated_checkout', function () {
            let orderReviewBody = $("#order_review .shop_table > tbody").clone()
            let orderReviewFoot = $("#order_review .shop_table > tfoot").clone()
            let mobileBodySpot = $(".checkout_mobile__body__items__table")
            let mobileFootSpot = $(".checkout_mobile__inner__bottom")

            mobileBodySpot.html('')
            mobileFootSpot.html('')

            //search and string replace coupon-input-desktop to coupon-input-mobile
            orderReviewFoot.find('.coupon-input-desktop').each(function () {
                $(this).removeClass('coupon-input-desktop').addClass('coupon-input-mobile')
            })

            // remove srcset attribute from images in orderReviewFoot - Fix mobile bug
            orderReviewBody.find('img').removeAttr('srcset')

            mobileBodySpot.html(orderReviewBody)
            mobileFootSpot.html(orderReviewFoot)
        })


        // Expand and collapse the mobile checkout view
        $(document).on("click", ".expand-trigger", function () {
            $(".checkout_mobile__inner").toggleClass("expand-trigger")
            $(".checkout_mobile__title__up").toggleClass("expand-trigger")
            $(".checkout_mobile__inner").toggleClass("open")
            $(".checkout_mobile__title__bottom").toggleClass("hidden")
        })


    }
}